import store from '../store';

export const updatePageTitle = (pageTitle) => {
  document.title = pageTitle;
};
export const getPathName = (pathname = window.location.pathname) => pathname;
export const isImzFlowType = window.location.pathname.includes('imoffer');
export const isRxFlowType = window.location.pathname.includes('rxoffer');
// NOSONAR
// export const isImzFlowType = true;

export const getStoreDetails = () =>
  JSON.parse(localStorage.getItem('abStoreAddress'));

export const bannerNameValueFunc = (hostName = window.location.hostname) => {
  const bannerNameTextValue = hostName?.includes('www')
    ? hostName.split('.')[1]
    : 'albertsons';

  return bannerNameTextValue;
};

export const getUrlBaseValue = () => {
  const urlBasePrefix = `${
    process.env.REACT_APP_SHORT_REG_URL_PREFIX
  }.${bannerNameValueFunc()}.com/${
    process.env.REACT_APP_PHARMACY_URL_SUFFIX
  }/incentivebackend/`;
  return urlBasePrefix;
};
export const updatePlatform = (screenWidth = screen.width) => {
  const screenType = screenWidth > 960 ? 'web' : 'mobile';
  return screenType;
};
export const updatePlatformDataLayer = (screenWidth = screen.width) => {
  const screenType = screenWidth > 960 ? 'web' : 'web-mobile';
  return screenType;
};
export const includeAdditionalInfo = (obj) => {
  const additionalInfo = store.getState().aditionalUserInfo;
  return { ...obj, ...additionalInfo };
};
export const includeOfferEligibilityDetails = (obj) => {
  const { heroText } = store.getState().bannerDetails;
  return includeAdditionalInfo({ ...obj, banner: heroText });
};
